import React, { useState } from "react";
import ReactQuill from "react-quill";
import 'react-quill/dist/quill.snow.css';
import MediaFormat from "../../../global/MediaFormat/MediaFormat";
import Input from "../../../global/form/Input/Input";
import "./StepDetails.scss";

const StepDetails = ({ formData, setFormData, setCurrentStep }) => {
  const [errors, setErrors] = useState({});

  const updateField = (field, value) => {
    setFormData((prevState) => ({
      ...prevState,
      [field]: value,
    }));
  };

  const stripHtmlTags = (html) => {
    const tmp = document.createElement("div");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  };

  const validateStepDetails = (formData) => {
    const newErrors = {};

    if (!formData.mediaType) {
      newErrors.mediaType = "Selecione o tipo de mídia.";
    }

    if (!formData.title.trim()) {
      newErrors.title = "Insira um título.";
    }

    const plainText = stripHtmlTags(formData.content);
    if (plainText.length < 100) {
      newErrors.content = "O conteúdo precisa ter pelo menos 100 caracteres.";
    }

    return newErrors;
  };



  return (
    <div className="StepDetails">
      <div className="link-content">
        <Input
          label="Link do conteúdo"
          placeholder="http://www.replit.com"
          value={formData.contentOriginUrl}
          updateState={(val) => {
            updateField("contentOriginUrl", val);
            setErrors(prev => ({ ...prev, contentOriginUrl: undefined }));
          }}
          displayError={!!errors.contentOriginUrl}
          errorMessage={errors.contentOriginUrl}
        />
        <p className="flutuant-link">Cole uma URL externa se quiser linkar a notícia.</p>
      </div>

      <div className="media-types">
        <label>Tipo de mídia</label>
        <div className="media-options">
          <MediaFormat
            checked={formData.mediaType === "TEXT"}
            label="Texto"
            updateState={() => updateField("mediaType", "TEXT")}
          />
          <MediaFormat
            checked={formData.mediaType === "AUDIO"}
            label="Áudio"
            updateState={() => updateField("mediaType", "AUDIO")}
          />
          <MediaFormat
            checked={formData.mediaType === "VIDEO"}
            label="Vídeo"
            updateState={() => updateField("mediaType", "VIDEO")}
          />
        </div>
      </div>

      <Input
        label="Título"
        placeholder="Dê um título para seu conteúdo"
        value={formData.title}
        updateState={(val) => {
          updateField("title", val);
          setErrors(prev => ({ ...prev, title: undefined }));
        }}
        displayError={!!errors.title}
        errorMessage={errors.title}
      />


      <Input
        label="Descrição"
        placeholder="Dê uma breve descrição para o seu conteúdo"
        value={formData.shortDescription}
        maxLength={300}
        updateState={(val) => {
          updateField("shortDescription", val);
        }}
        className={"short-description"}
        displayError={!!errors.shortDescription}
        errorMessage={errors.shortDescription}
      />


      <div className="editor-content">
        <label>Conteúdo</label>
        <ReactQuill
          value={formData.content}
          onChange={(val) => {
            updateField("content", val);
            setErrors(prev => ({ ...prev, content: undefined }));
          }}
          className={`react-quill ${errors.content ? 'editor-error' : ''}`}
          modules={{
            toolbar: [
              [{ 'header': '1' }, { 'header': '2' }, { "color": [] }, { "background": [] }],
              [{ 'size': ['small', false, 'large', 'huge'] }],
              [{ 'list': 'ordered' }, { 'list': 'bullet' }],
              ['bold', 'italic', 'underline'],
              [{ 'align': [] }],
              ['link', 'image'],
              ['clean']
            ]
          }}
          style={{
            border: "1px solid #d9d9d9",
            borderRadius: "8px",
            padding: "5px",
            maxWidth: "1200px",
            boxSizing: "border-box"
          }}
          placeholder="Digite seu conteúdo aqui..."
        />
        {errors.content && <p className="error-message">{errors.content}</p>}
        <p className="description-editor">Este é o corpo principal do seu artigo. Torne-o informativo e envolvente.</p>
      </div>


      <div className="writing-tips">
        <strong>Dicas de redação:</strong>
        <ul>
          <li>Comece com as informações mais importantes</li>
          <li>Use parágrafos curtos e linguagem clara</li>
          <li>Inclua citações e fontes relevantes</li>
          <li>Forneça contexto e informações básicas</li>
          <li>Termine com uma conclusão forte ou um apelo à ação</li>
        </ul>
      </div>

      <button
        onClick={() => {
          const validationErrors = validateStepDetails(formData);

          if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
          }

          setErrors({});
          setCurrentStep("Tags");
        }}
        className="continue-button"
      >
        Continuar
      </button>


    </div>

  );
};

export default StepDetails;
